(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["concept-header"]) return;
  try {
    
class ConceptStickyHeader extends HTMLElement {
  connectedCallback() {
    this.header = this.querySelector('.concept-header');
    this.type = this.dataset.stickyType;
    this.currentScrollTop = 0;
    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.type === 'always') {
      this.header.classList.add('concept-header--stuck');
    } else if (this.type === 'on-scroll-up') {
      if (scrollTop > this.currentScrollTop && scrollTop > 80) {
        this.header.classList.add('concept-header--hidden');
        this.header.classList.remove('concept-header--stuck');
      } else if (scrollTop < this.currentScrollTop) {
        this.header.classList.remove('concept-header--hidden');
        this.header.classList.add('concept-header--stuck');
      } else if (scrollTop <= 0) {
        this.header.classList.remove('concept-header--hidden', 'concept-header--stuck');
      }
    }

    this.currentScrollTop = scrollTop;
  }
}

if (!customElements.get('concept-sticky-header')) {
  customElements.define('concept-sticky-header', ConceptStickyHeader);
}

class ConceptHeaderMenuDelay {
  constructor(root) {
    this.root = root;
    this.hideDelay = 200;
    this.timers = new WeakMap();
    this.mediaQuery = window.matchMedia('(min-width: 1100px)');
    this.mediaQuery.addEventListener('change', () => this.bind());
    this.bind();
  }

  bind() {
    this.root.querySelectorAll('.concept-list-menu > li').forEach((item) => {
      if (item.dataset.conceptBound) return;
      item.dataset.conceptBound = 'true';

      const hoverEnabled = item.dataset.hoverMenu === 'true';

      if (hoverEnabled) {
        item.addEventListener('mouseenter', () => {
          clearTimeout(this.timers.get(item));
          item.classList.add('concept-menu-hover-open');
        });
        item.addEventListener('mouseleave', () => {
          const t = setTimeout(() => item.classList.remove('concept-menu-hover-open'), this.hideDelay);
          this.timers.set(item, t);
        });
      } else {
        const trigger = item.querySelector(':scope > .concept-menu-item, :scope > .concept-mega-menu-trigger');
        if (trigger) {
          trigger.addEventListener('click', (e) => {
            const hasSubmenu = item.querySelector(':scope > .concept-submenu, :scope > .concept-mega-menu');
            if (hasSubmenu) {
              e.preventDefault();
              const isOpen = item.classList.contains('concept-click-open');
              this.root.querySelectorAll('.concept-click-open').forEach((el) => el.classList.remove('concept-click-open'));
              if (!isOpen) item.classList.add('concept-click-open');
            }
          });
        }
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.concept-header__nav').forEach((nav) => new ConceptHeaderMenuDelay(nav));

  // 抽屉菜单开关
  document.querySelectorAll('[data-concept-drawer-open]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const section = btn.closest('[data-section-id]');
      const id = section ? section.dataset.sectionId : '';
      const drawer = document.getElementById('ConceptMenuDrawer-' + id);
      const overlay = document.getElementById('ConceptOverlay-' + id);
      if (drawer) {
        drawer.hidden = false;
        overlay && overlay.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
      }
    });
  });

  document.querySelectorAll('[data-concept-drawer-close]').forEach((btn) => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.concept-menu-drawer').forEach((d) => (d.hidden = true));
      document.querySelectorAll('.concept-overlay').forEach((o) => o.classList.remove('is-visible'));
      document.body.style.overflow = '';
    });
  });

  // mega_menu_tab 选项卡切换
  document.querySelectorAll('.concept-mega-tabs').forEach((tabs) => {
    const buttons = tabs.querySelectorAll('.concept-mega-tabs__tab');
    const panels = tabs.querySelectorAll('.concept-mega-tabs__panel');
    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.tabTarget;
        buttons.forEach((b) => b.setAttribute('aria-selected', b === btn ? 'true' : 'false'));
        panels.forEach((p) => p.dataset.active = p.dataset.tabPanel === target ? 'true' : 'false');
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
 class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		activeMedia.classList.add('active');
		activeMedia.scrollIntoView();

		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  //class ProductRecommendations2 extends HTMLElement {
  //  constructor() {
  //    super();

  //    const handleIntersection = (entries, observer) => {
  //      if (!entries[0].isIntersecting) return;
  //      observer.unobserve(this);

  //      fetch(this.dataset.url)
  //        .then((response) => response.text())
  //        .then((text) => {
  //          const html = document.createElement('div');
  //          html.innerHTML = text;
  //          const recommendations = html.querySelector('product-recommendations2');
  //          if (recommendations && recommendations.innerHTML.trim().length) {
  //            this.innerHTML = recommendations.innerHTML;
  //          }
  //        })
  //        .catch((e) => {
  //          console.error(e);
  //        });
  //    };

  //    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
  //  }
  //}

  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations', ProductRecommendations);
  //customElements.define('product-recommendations2', ProductRecommendations2);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
	constructor() {
	super();
}

connectedCallback() {
	this.header = document.querySelector('.shopify-section-header');
	this.header1 = document.querySelector('.header-wrapper--under-menu')
	this.header_wrapper = document.querySelector('.header-wrapper');
	this.header__offcanvas_menu = document.querySelector('.header__offcanvas-menu');
	this.predictiveSearch = this.querySelector('predictive-search');
	this.headerBounds = {};
	this.currentScrollTop = 0;

	this.onScrollHandler = this.onScroll.bind(this);

	window.addEventListener('scroll', this.onScrollHandler, false);

	this.createObserver();
}

disconnectedCallback() {
	window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
	if (!this.header) return;

	let observer = new IntersectionObserver((entries, observer) => {
	this.headerBounds = entries[0].intersectionRect;
	observer.disconnect();
});

	observer.observe(this.header);
}

onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.hide.bind(this));
		if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
		this.predictiveSearch.onFocusOut();
		this.predictiveSearch.onBlur();
	} 
	} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.reveal.bind(this));
	} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
}

	hide() {
		if (!this.header) return;

		if(this.header1){
			this.header.classList.add('shopify-section-header-fixed-hidden', 'shopify-section-header-sticky', 'animate');
		}
		else {
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
			this.closeMenuDisclosure();
		}
	// this.closeSearchModal();
}

reveal() {
	if (!this.header) return;

	if(this.header1){
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-fixed-hidden');
			this.header_wrapper?.classList.add('header-wrapper--under-menu-full');
		}
	else {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
	}
	this.header__offcanvas_menu?.classList.add('header__offcanvas_menu-reveal')
}

reset() {
	if (!this.header) return;

	if(this.header1){
		this.header.classList.remove('shopify-section-header-fixed-hidden', 'shopify-section-header-sticky', 'animate');
		this.header_wrapper?.classList.remove('header-wrapper--under-menu-full');
	}
	else {
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}
	this.header__offcanvas_menu?.classList.remove('header__offcanvas_menu-reveal')

}

closeMenuDisclosure() {
	if (!this.header) return;

	this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
	this.disclosures.forEach(disclosure => disclosure?.close());
}

// closeSearchModal() {
// 	this.searchModal = this.searchModal || this.header.querySelector('details-modal');
// 	this.searchModal.close(false);
// }
}

customElements.define('sticky-header', StickyHeader);

class HeaderMenuDropdownDelay {
	constructor() {
		const delayValue = getComputedStyle(document.documentElement).getPropertyValue('--header-menu-hide-delay').trim();
		this.hideDelay = parseInt(delayValue, 10) || 300;
		this.timers = new Map();
		this.mediaQuery = window.matchMedia('(min-width: 1100px)');
		this.onMediaChange = this.handleMediaChange.bind(this);
		this.boundItems = new WeakMap();

		this.mediaQuery.addEventListener('change', this.onMediaChange);
		this.handleMediaChange();
	}

	handleMediaChange() {
		this.clearAll();

		if (this.mediaQuery.matches) {
			this.bindMenus();
		}
	}

	bindMenus() {
		const inlineMenu = document.querySelector('.header__inline-menu');
		if (!inlineMenu) return;

		inlineMenu.querySelectorAll('.list-menu--inline > li').forEach((item) => {
			this.bindItem(item);
		});

		inlineMenu.querySelectorAll('.header__submenu > li').forEach((item) => {
			if (item.querySelector(':scope > .header__submenu')) {
				this.bindItem(item);
			}
		});
	}

	bindItem(item) {
		if (this.boundItems.has(item)) return;

		const onEnter = () => this.openItem(item);
		const onLeave = () => this.scheduleClose(item);

		item.addEventListener('mouseenter', onEnter);
		item.addEventListener('mouseleave', onLeave);
		this.boundItems.set(item, { onEnter, onLeave });
	}

	openItem(item) {
		const timerId = item.dataset.menuDelayId;

		if (timerId) {
			clearTimeout(Number(timerId));
			delete item.dataset.menuDelayId;
		}

		const parent = item.parentElement;

		if (parent) {
			parent.querySelectorAll(':scope > li.menu-hover-open').forEach((openItem) => {
				if (openItem !== item) {
					this.closeItem(openItem);
				}
			});
		}

		item.classList.add('menu-hover-open');
	}

	scheduleClose(item) {
		const existingTimerId = item.dataset.menuDelayId;

		if (existingTimerId) {
			clearTimeout(Number(existingTimerId));
		}

		const timer = window.setTimeout(() => {
			this.closeItem(item);
		}, this.hideDelay);

		item.dataset.menuDelayId = String(timer);
		this.timers.set(item, timer);
	}

	closeItem(item) {
		const timerId = item.dataset.menuDelayId;

		if (timerId) {
			clearTimeout(Number(timerId));
			delete item.dataset.menuDelayId;
		}

		item.classList.remove('menu-hover-open');
		this.timers.delete(item);
	}

	clearAll() {
		document.querySelectorAll('.header__inline-menu .menu-hover-open').forEach((item) => {
			this.closeItem(item);
		});
	}
}

const initHeaderMenuDropdownDelay = () => {
	if (!window.headerMenuDropdownDelay) {
		window.headerMenuDropdownDelay = new HeaderMenuDropdownDelay();
	} else {
		window.headerMenuDropdownDelay.handleMediaChange();
	}
};

document.addEventListener('DOMContentLoaded', initHeaderMenuDropdownDelay);
document.addEventListener('shopify:section:load', initHeaderMenuDropdownDelay);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
 class ProductModal extends ModalDialog {
	constructor() {
		super();
		this.bindCloseControls();
	}

	connectedCallback() {
		super.connectedCallback();
		this.bindCloseControls();
	}

	bindCloseControls() {
		if (this._closeControlsBound) return;

		const closeButton = this.querySelector('.product-media-modal__toggle, [id^="ModalClose-"]');
		if (closeButton) {
			closeButton.addEventListener('click', (event) => {
				event.preventDefault();
				event.stopPropagation();
				this.hide();
			});
		}

		this.addEventListener('keydown', (event) => {
			if (event.code && event.code.toUpperCase() === 'ESCAPE') {
				event.preventDefault();
				this.hide();
			}
		});

		this._closeControlsBound = true;
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	getOpenedMediaId() {
		if (!this.openedBy) return null;

		return (
			this.openedBy.getAttribute('data-media-id') ||
			this.openedBy.closest('[data-media-id]')?.getAttribute('data-media-id') ||
			null
		);
	}

	findModalMedia(mediaId) {
		if (!mediaId) return null;

		let activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
		if (activeMedia) return activeMedia;

		const mediaKey = String(mediaId).includes('-')
			? String(mediaId).split('-').pop()
			: String(mediaId);

		return this.querySelector(`[data-media-id="${mediaKey}"]`);
	}

	showActiveMedia() {
		const mediaId = this.getOpenedMediaId();
		if (!mediaId) return;

		this.querySelectorAll('[data-media-id]').forEach((element) => {
			const elementMediaId = element.getAttribute('data-media-id');
			const isActive =
				elementMediaId === mediaId ||
				elementMediaId === String(mediaId).split('-').pop();

			element.classList.toggle('active', isActive);
		});

		const activeMedia = this.findModalMedia(mediaId);
		if (!activeMedia) return;

		activeMedia.classList.add('active');
		activeMedia.scrollIntoView();

		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  //class ProductRecommendations2 extends HTMLElement {
  //  constructor() {
  //    super();

  //    const handleIntersection = (entries, observer) => {
  //      if (!entries[0].isIntersecting) return;
  //      observer.unobserve(this);

  //      fetch(this.dataset.url)
  //        .then((response) => response.text())
  //        .then((text) => {
  //          const html = document.createElement('div');
  //          html.innerHTML = text;
  //          const recommendations = html.querySelector('product-recommendations2');
  //          if (recommendations && recommendations.innerHTML.trim().length) {
  //            this.innerHTML = recommendations.innerHTML;
  //          }
  //        })
  //        .catch((e) => {
  //          console.error(e);
  //        });
  //    };

  //    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
  //  }
  //}

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations', ProductRecommendations);
  //customElements.define('product-recommendations2', ProductRecommendations2);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
	const productRecommendationsSlider = () => {
		$(document).ready(function () {
			$('.js-product-recommendations').each(function (index, parent) {
				let parentId = `#${$(parent).attr('id')}`;

				let carousel = document
					.querySelector(parentId)
					.querySelector(`.js-swiper-product-recommendations`);

				let scrollBar = document
					.querySelector(parentId)
					.querySelector(`.js-product-recommendations-swiper-scrollbar`);

				let prev = document
					.querySelector(parentId)
					.querySelector(`.js-product-recommendations-arrow-prev`);

				let next = document
					.querySelector(parentId)
					.querySelector(`.js-product-recommendations-arrow-next`);

				let swiperCarousel = new Swiper(carousel, {
					slidesPerView: 3,
					spaceBetween: 8,
					scrollbar: {
						el: scrollBar,
						draggable: true,
					},
					navigation: {
						prevEl: prev,
						nextEl: next,
					},
					breakpoints: {
						0: { slidesPerView: 1 },
						920: { slidesPerView: 2 },
						1100: { slidesPerView: 3 },
						1200: { slidesPerView: 2 },
						1300: { slidesPerView: 3 },
						1500: { slidesPerView: 3 },
						1800: { slidesPerView: 3 },
					},
				});

				if (
					$('.js-product-recommendations-arrow-prev').hasClass(
						'swiper-button-lock'
					) ||
					$('.js-product-recommendations-arrow-next').hasClass(
						'swiper-button-lock'
					)
				) {
					$('.nav-tools').css('display', 'none');
				}
			});
		});
	};

	class ProductRecommendations2 extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations2'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
							productRecommendationsSlider();
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations2', ProductRecommendations2);

	document.addEventListener('shopify:section:load', function () {
		productRecommendationsSlider();
	});

  } catch(e) { console.error(e); }
})();
})();
